"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuotoneLayersIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const makeIcon_1 = require("./makeIcon");
const DuotoneLayers = props => ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 5l8-5 8 5-8 5-8-5z", fill: "#fff" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M0 11l8-5 8 5-8 5-8-5z", fill: "#fff", fillOpacity: ".4" }, void 0)] }), void 0));
exports.DuotoneLayersIcon = (0, makeIcon_1.makeIcon)("duotoneLayers")(DuotoneLayers);
//# sourceMappingURL=DuotoneLayers.js.map